export const BANK_ID_PAYMENTS_REPORT_UPDATED = "BANK_ID_PAYMENTS_REPORT_UPDATED";
export const BANK_ID_PAYMENTS_REPORT_COMPLETED = "BANK_ID_PAYMENTS_REPORT_COMPLETED";
